export const UPP_SB_PAYMENT_COMPONENTS = 'sb2727-payment-components';
